module.exports = __webpack_public_path__ + "static/img/01.d015e74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/01.png
// module id = xDpK
// module chunks = 2